import { NumericFormat as NumberFormat } from 'react-number-format';
import { CurrencyFormatDisplay } from '@/components/UI/NumberFormatDisplay/CurrencyFormatDisplay';
import { PhoneNumberFormatDisplay } from '@/components/UI/NumberFormatDisplay/PhoneNumberFormatDisplay';

export const HowStructure = ({ howStructure }: any) => {
  return (
    <section aria-labelledby='applicant-information-title'>
      <div className='bg-white shadow sm:rounded-lg'>
        <div className='py-5'>
          <div className='px-4 py-2 sm:px-6 border-l-4 border-primaryColor-normal'>
            <h2 id='applicant-information-title' className='m-0 text-lg leading-6 font-medium text-primaryColor-normal'>
              House of Worship Structure
            </h2>
            <p className='mt-1 max-w-2xl text-sm text-gray-500'>Information about the structure of your House of Worship</p>
          </div>
        </div>
        <div className='border-t border-gray-200 px-4 py-5 sm:px-6'>
          <dl className='grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 mb-8'>
            <div className='sm:col-span-2'>
              <dt className='text-sm font-medium text-gray-500'>
                Is there a board within the house of worship responsible for a development ?
              </dt>
              <dd className='mt-1 text-sm text-gray-900'>{howStructure?.q1}</dd>
            </div>
            {howStructure?.q1 === 'yes' && (
              <>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>Board Chair</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{howStructure['q1-boardChair']}</dd>
                </div>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>Phone</dt>
                  <dd className='mt-1 text-sm text-gray-900'>
                    <PhoneNumberFormatDisplay value={howStructure['q1-phone']} />
                  </dd>
                </div>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>Email</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{howStructure['q1-email']}</dd>
                </div>
              </>
            )}
            <div className='sm:col-span-2'>
              <dt className='text-sm font-medium text-gray-500'>
                Is there a non-profit organization affiliated with the house of worship ?
              </dt>
              <dd className='mt-1 text-sm text-gray-900'>{howStructure?.q2}</dd>
            </div>
            <div className='sm:col-span-2'>
              <dt className='text-sm font-medium text-gray-500'>
                Does organization process 501(c)3 tax exempt status or is in the process of securing it ?
              </dt>
              <dd className='mt-1 text-sm text-gray-900'>{howStructure?.q3}</dd>
            </div>
            {howStructure?.q3 === 'yes' && (
              <>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>Name of Non-Profit</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{howStructure['q3-nonProfitName']}</dd>
                </div>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>Address of Non-Profit</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{howStructure['q3-nonProfitAddress']}</dd>
                </div>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>website</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{howStructure['q3-website'] ? howStructure['q3-website'] : '-'}</dd>
                </div>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>Organizational Leader</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{howStructure['q3-executiveDirector']}</dd>
                </div>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>Phone</dt>
                  <dd className='mt-1 text-sm text-gray-900'>
                    <PhoneNumberFormatDisplay value={howStructure['q3-phone']} />
                  </dd>
                </div>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>Email</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{howStructure['q3-email']}</dd>
                </div>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>No. of Full-Time Staff</dt>
                  <dd className='mt-1 text-sm text-gray-900'>
                    <NumberFormat value={howStructure['q3-fteCount']} thousandSeparator={true} displayType={'text'} />
                  </dd>
                </div>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>No. of Part-Time Staff</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{howStructure['q3-pteCount'] ? howStructure['q3-pteCount'] : '-'}</dd>
                </div>
                {howStructure['q3-volunteersCount'] && (
                  <div className='sm:col-span-1'>
                    <dt className='text-sm font-medium text-gray-500'>No. of Volunteers</dt>
                    <dd className='mt-1 text-sm text-gray-900'>{howStructure['q3-volunteersCount']}</dd>
                  </div>
                )}
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>Total Operating Budget</dt>
                  <dd className='mt-1 text-sm text-gray-900'>
                    <CurrencyFormatDisplay value={howStructure['q3-operatingBudget'] ? howStructure['q3-operatingBudget'] : 0} prefix='$' />
                  </dd>
                </div>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>Years Providing Services</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{howStructure['q3-yearsService']}</dd>
                </div>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>Date of Last Board Meeting</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{howStructure['q3-meetingDate'] ? howStructure['q3-meetingDate'] : '-'}</dd>
                </div>
              </>
            )}
          </dl>
        </div>
      </div>
    </section>
  );
};
